import React from 'react';
import FilterSample  from '../components/filterSample/FilterSample';


function Home() {
	return (
		<>
			<FilterSample />
		</>
	)
}

export default Home;